import { IRequestFailure } from "store/entities/actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IApplication } from "store/entities/applications";
import { ActionsUnion, createAction } from "store/helper";

import { IHandlePutMessageParams } from "./interfaces";

export enum ApplicationsActionNames {
  LOAD_WIDGET = "FEATURES/APPLICATIONS/LOAD",
  LOAD_FULLSCREEN_WIDGET = "FEATURES/APPLICATIONS/LOAD_FULLSCREEN_WIDGET",
  CONNECTION_ESTABLISHED = "FEATURES/APPLICATIONS/CONNECTION_ESTABLISHED",
  WIDGETS_DISABLE = "FEATURES/APPLICATIONS/WIDGETS_DISABLE",

  // Manage applications
  INSTALL_APPLICATION = "FEATURES/APPLICATIONS/INSTALL_APPLICATION",
  INSTALL_APPLICATION_SUCCESSFUL = "FEATURES/APPLICATIONS/INSTALL_APPLICATION_SUCCESSFUL",
  INSTALL_APPLICATION_FAILURE = "FEATURES/APPLICATIONS/INSTALL_APPLICATION_FAILURE",
  UNINSTALL_APPLICATION = "FEATURES/APPLICATIONS/UNINSTALL_APPLICATION",
  UNINSTALL_APPLICATION_SUCCESSFUL = "FEATURES/APPLICATIONS/UNINSTALL_APPLICATION_SUCCESSFUL",
  UNINSTALL_APPLICATION_FAILURE = "FEATURES/APPLICATIONS/UNINSTALL_APPLICATION_FAILURE",

  // Agent App Widgets event handlers
  HANDLE_PUT_MESSAGE = "FEATURES/APPLICATIONS/HANDLE/PUT_MESSAGE",
}

export const ApplicationsActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  loadWidget: (id: string) => createAction(ApplicationsActionNames.LOAD_WIDGET, { id }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  loadFullscreenWidget: (id: string) => createAction(ApplicationsActionNames.LOAD_FULLSCREEN_WIDGET, { id }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  connectionEstablished: (pluginId: string, connectionId: string) =>
    createAction(ApplicationsActionNames.CONNECTION_ESTABLISHED, { pluginId, connectionId }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  disableWidgets: (payload: any) => createAction(ApplicationsActionNames.WIDGETS_DISABLE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handlePutMessage: (payload: IHandlePutMessageParams) =>
    createAction(ApplicationsActionNames.HANDLE_PUT_MESSAGE, payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  installApplication: (id: string) => createAction(ApplicationsActionNames.INSTALL_APPLICATION, { id }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  installApplicationSuccessful: (payload: IApplication) =>
    createAction(ApplicationsActionNames.INSTALL_APPLICATION_SUCCESSFUL, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  installApplicationFailure: (payload: IRequestFailure) =>
    createAction(ApplicationsActionNames.INSTALL_APPLICATION_FAILURE, payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  uninstallApplication: (id: string, redirectTo?: string, reason?: string) =>
    createAction(ApplicationsActionNames.UNINSTALL_APPLICATION, { id, redirectTo, reason }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  uninstallApplicationSuccessful: (id: string) =>
    createAction(ApplicationsActionNames.UNINSTALL_APPLICATION_SUCCESSFUL, { id }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  uninstallApplicationFailure: (payload: IRequestFailure) =>
    createAction(ApplicationsActionNames.UNINSTALL_APPLICATION_FAILURE, payload),
};

export type ApplicationsAction = ActionsUnion<typeof ApplicationsActions>;
